<template>
  
        <div class="modal fade show">
            <div class="modal-dialog" :class="size!=undefined?'modal-'+size:''">
                <div class="modal-content">
                    <div class="modal-header" v-if="title!=undefined">
                        <h4 class="modal-title">{{title}}</h4>
                        <button class="close" type="button"  @click="$emit('close')">×</button>
                    </div>
                        <slot name="head"></slot>
                    <div class="modal-body p-0">
                        <slot name="content"></slot>
                    </div>
                    <div class="modal-footer" v-if="$slots.foot!=undefined">
                        <slot name="foot"></slot>
                        <!-- <button type="button" tabindex="2" @click="add" class="btn btn-success btn-md waves-effect text-left" :disabled="addProcess" :class="addProcess?'load':''">
                            <span>Şube Ekle</span>
                            <svg class="circular" viewBox="25 25 50 50">
                                <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="3" stroke-miterlimit="10"></circle> 
                            </svg>
                        </button> -->
                    </div>
                </div>
            </div>
            <div class="overlay" @click="$emit('close')"></div>
        </div>
</template>

<script>
    export default {
        name:"modal",
        props:{
            title:String,
            size:String
        }
    }
</script>

<style>

</style>